import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import './SearchResultsTable.css'

type sanctionScreeningConsumer = {
  firstname?: string
  surname?: string
  idno?: string
  name?: string
  enquiryID?: string
  enquiryResultID?: string
}

type Props = {
  sanctionScreeningConsumers: sanctionScreeningConsumer[]

  setSanctionScreeningConsumer: (consumer: sanctionScreeningConsumer) => void
}

const TableDataSanctionScreening: React.FC<Props> = ({
  sanctionScreeningConsumers,
  setSanctionScreeningConsumer,
}) => (
  <div className="kyc-sanction-results-table-container">
    <table>
      <thead>
        <tr>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Firstname
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Surname
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Id number
          </td>
        </tr>
      </thead>
      <tbody>
        {sanctionScreeningConsumers.map((sanctionScreeningConsumer) => (
          <tr
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSanctionScreeningConsumer(sanctionScreeningConsumer)
            }}
          >
            <td>{sanctionScreeningConsumer.firstname}</td>
            <td>{sanctionScreeningConsumer.surname}</td>
            <td>{sanctionScreeningConsumer.idno}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default TableDataSanctionScreening
